/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility';

const WatchingOff = (props) => <VisibilityIcon {...props} style={{ opacity: 0.3 }} />;

export default WatchingOff;
